import { useTransactionLoader } from './useTransactionLoader';
import { useTransactionFilter } from './useTransactionFilter';
import { useTransactionSort } from './useTransactionSort';
import { useTransactionMatching } from './useTransactionMatching';
import { useTransactionFilterState } from './useTransactionFilterState';
import { formatCurrency } from "@/utils/paymentUtils";

export function useTransactions() {
  // Manage filter state
  const {
    selectedTab,
    setSelectedTab,
    selectedAccounts,
    setSelectedAccounts,
    filters,
    handleFilterChange,
    resetFilters
  } = useTransactionFilterState();

  // Load transaction data
  const {
    transactions,
    setTransactions,
    loadingTransactions,
    transactionsError,
    loadTransactions,
    page,
    pageSize,
    total,
    setPage
  } = useTransactionLoader(selectedAccounts, filters);

  // Filter transactions
  const filteredTransactions = useTransactionFilter(
    transactions,
    filters,
    selectedTab,
  );

  // Sort transactions
  const {
    sortKey,
    sortDirection,
    sortedTransactions,
    handleSort,
    renderSortIcon
  } = useTransactionSort(filteredTransactions);

  // Transaction matching functionality
  const {
    selectedTransactionId,
    setSelectedTransactionId,
    selectedTransaction,
    handleManualMatch,
    handleMatchSelection,
    handleConfirmPayableMatch,
    handleConfirmOwnAccountMatch
  } = useTransactionMatching(transactions, setTransactions);

  return {
    // Transaction data
    transactions,
    loadingTransactions,
    transactionsError,
    loadTransactions,

    // Pagination surface (issue #363) — server-paginated page of the persisted store.
    page,
    pageSize,
    total,
    setPage,

    // Filter state
    selectedTab,
    setSelectedTab,
    selectedAccounts,
    setSelectedAccounts,
    filters,
    handleFilterChange,
    resetFilters,
    
    // Filtered & sorted transactions
    filteredTransactions,
    sortedTransactions,
    
    // Sorting
    sortKey,
    sortDirection,
    handleSort,
    renderSortIcon,
    
    // Matching
    selectedTransactionId,
    setSelectedTransactionId,
    selectedTransaction,
    handleManualMatch,
    handleMatchSelection,
    handleConfirmPayableMatch,
    handleConfirmOwnAccountMatch
  };
}
